import {
  AuthFormBoxRowGaps,
  AuthFormBoxTemplate,
  TextBlock,
  TextBlockDirection,
  TextBlockRowGap,
  TextBoxHeadline2,
} from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { AuthTabs } from '~/features/change-auth-type'
import {
  RegistrationByEmailForm,
  RegistrationByPhoneForm,
  SignUpErrorMessage,
  model as signUpModel,
} from '~/features/subscriber/sign-up'
import { SignInLink } from './SignInLink'
import { $signUpFormTranslations } from './i18n'
import { $isSignUpByEmailActivated, $isSignUpByPhoneActivated } from './model'

export const SignUpForm = () => {
  const formTranslations = useUnit($signUpFormTranslations)

  const isPhoneRegistration = useUnit($isSignUpByPhoneActivated)
  const isEmailRegistration = useUnit($isSignUpByEmailActivated)

  const signUpWithPhoneEnabled = useUnit(signUpModel.$signUpWithPhoneEnabled)
  const rowGap = signUpWithPhoneEnabled
    ? AuthFormBoxRowGaps.SIZE_160
    : AuthFormBoxRowGaps.SIZE_150

  return (
    <AuthFormBoxTemplate rowGap={rowGap}>
      <TextBoxHeadline2 title={formTranslations.title} />
      {signUpWithPhoneEnabled && <AuthTabs />}
      {isPhoneRegistration && <RegistrationByPhoneForm />}
      {isEmailRegistration && <RegistrationByEmailForm />}

      <TextBlock
        direction={TextBlockDirection.ROW}
        rowGap={TextBlockRowGap.INDENT_20}
      >
        <SignInLink />
      </TextBlock>
      <SignUpErrorMessage />
    </AuthFormBoxTemplate>
  )
}
